<div class="datos-modal">
  <div class="datos-modal__header">
    <h2 class="datos-modal__title">Completa todos los datos</h2>
    <button type="button" class="datos-modal__close" (click)="cancel()" aria-label="Cerrar">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <div class="datos-modal__body">
  <div class="workspace-row workspace-row--inline workspace-row--field workspace-row--return" *ngIf="askReturnQuantity">
    <label class="workspace-label" for="modalDevM3">cantidad retornada (m3)</label>
    <div class="datos-field datos-field--narrow">
      <input
        id="modalDevM3"
        class="workspace-input workspace-input--narrow"
        [class.is-invalid]="errors.m3Returned"
        type="number"
        min="0"
        step="0.1"
        required
        [attr.aria-invalid]="!!errors.m3Returned"
        [attr.aria-describedby]="errors.m3Returned ? 'modalDevM3Error' : null"
        [(ngModel)]="m3Returned"
        (ngModelChange)="onFieldChange()" />
      <small id="modalDevM3Error" class="datos-field__error" *ngIf="errors.m3Returned">
        {{ errors.m3Returned }}
      </small>
    </div>
  </div>

  <div class="workspace-row workspace-row--inline workspace-row--field">
    <label class="workspace-label" for="modalRut">RUT</label>
    <div class="datos-field">
      <div class="rut-group">
        <input
          id="modalRut"
          class="workspace-input"
          [class.is-invalid]="errors.rut"
          type="text"
          maxlength="8"
          placeholder="Ingresa tu RUT"
          required
          [attr.aria-invalid]="!!errors.rut"
          [attr.aria-describedby]="errors.rut || errors.dv ? 'modalRutError' : null"
          [(ngModel)]="rut"
          (ngModelChange)="onFieldChange()" />
        <input
          class="workspace-input workspace-input--dv"
          [class.is-invalid]="errors.dv"
          type="text"
          maxlength="1"
          required
          aria-label="Dígito verificador"
          [attr.aria-invalid]="!!errors.dv"
          [attr.aria-describedby]="errors.rut || errors.dv ? 'modalRutError' : null"
          [ngModel]="dv"
          (ngModelChange)="onDvChange($event)" />
      </div>
      <small id="modalRutError" class="datos-field__error" *ngIf="errors.rut || errors.dv">
        {{ errors.rut || errors.dv }}
      </small>
    </div>
  </div>

  <div class="workspace-row workspace-row--inline workspace-row--field">
    <label class="workspace-label" for="modalName">Nombre</label>
    <div class="datos-field">
      <input
        id="modalName"
        class="workspace-input"
        [class.is-invalid]="errors.name"
        type="text"
        placeholder="Ingresa tu nombre"
        required
        [attr.aria-invalid]="!!errors.name"
        [attr.aria-describedby]="errors.name ? 'modalNameError' : null"
        [(ngModel)]="name"
        (ngModelChange)="onFieldChange()" />
      <small id="modalNameError" class="datos-field__error" *ngIf="errors.name">
        {{ errors.name }}
      </small>
    </div>
  </div>

  <div class="workspace-row workspace-row--inline workspace-row--field" *ngIf="showEmail">
    <label class="workspace-label" for="modalEmail">Correo</label>
    <div class="correo-wrap datos-field">
      <input
        id="modalEmail"
        class="workspace-input"
        [class.is-invalid]="errors.email"
        type="email"
        placeholder="Ingresa tu correo"
        [attr.aria-invalid]="!!errors.email"
        [attr.aria-describedby]="errors.email ? 'modalEmailError' : null"
        [(ngModel)]="email"
        (ngModelChange)="onFieldChange()" />
      <small id="modalEmailError" class="datos-field__error" *ngIf="errors.email; else emailHint">
        {{ errors.email }}
      </small>
      <ng-template #emailHint>
        <small class="workspace-hint">
          Utilizaremos este para enviar una copia de la guía firmada.
        </small>
      </ng-template>
    </div>
  </div>

  <div class="workspace-row">
    <label class="workspace-label" for="modalComentario">comentarios</label>
    <div class="datos-field">
      <textarea
        id="modalComentario"
        class="workspace-textarea workspace-textarea--sm"
        [class.is-invalid]="errors.comentario"
        rows="3"
        placeholder="Ingresa tu observación"
        [required]="commentRequired"
        [attr.aria-invalid]="!!errors.comentario"
        [attr.aria-describedby]="errors.comentario ? 'modalComentarioError' : null"
        [(ngModel)]="comentario"
        (ngModelChange)="onFieldChange()"></textarea>
      <small id="modalComentarioError" class="datos-field__error" *ngIf="errors.comentario">
        {{ errors.comentario }}
      </small>
    </div>
  </div>

  <p class="firma-page__error form-error-summary" role="alert" *ngIf="error">
    <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
    {{ error }}
  </p>

  <div class="workspace-actions">
    <button type="button" class="btn-outline-firma" (click)="cancel()">
      Cerrar
    </button>
    <button type="button" class="btn-primary-firma" (click)="continue()">
      Guardar y Firmar
    </button>
  </div>
  </div>
</div>
